import { render } from "./MsgReceive.vue?vue&type=template&id=41014cfc&scoped=true"
import script from "./MsgReceive.vue?vue&type=script&lang=js"
export * from "./MsgReceive.vue?vue&type=script&lang=js"

import "./MsgReceive.vue?vue&type=style&index=0&id=41014cfc&lang=less&scoped=true"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41014cfc"]])

export default __exports__